var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.667 2.16602C9.82604 2.16602 8.33366 3.6584 8.33366 5.49935V7.16602H5.00033C3.15938 7.16602 1.66699 8.6584 1.66699 10.4993V15.4993C1.66699 17.3403 3.15938 18.8327 5.00033 18.8327H8.33366C10.1746 18.8327 11.667 17.3403 11.667 15.4993V13.8327H15.0003C16.8413 13.8327 18.3337 12.3403 18.3337 10.4993V5.49935C18.3337 3.6584 16.8413 2.16602 15.0003 2.16602H11.667ZM11.667 12.166H15.0003C15.9208 12.166 16.667 11.4198 16.667 10.4993V5.49935C16.667 4.57887 15.9208 3.83268 15.0003 3.83268H11.667C10.7465 3.83268 10.0003 4.57887 10.0003 5.49935V7.61196C10.9967 8.18831 11.667 9.26554 11.667 10.4993V12.166ZM3.33366 10.4993C3.33366 9.57887 4.07985 8.83268 5.00033 8.83268H8.33366C9.25413 8.83268 10.0003 9.57887 10.0003 10.4993V15.4993C10.0003 16.4198 9.25413 17.166 8.33366 17.166H5.00033C4.07985 17.166 3.33366 16.4198 3.33366 15.4993V10.4993Z",
    fill: "#98A2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.213c0e37420f467422a00c1232570183.svg";
export { ForwardRef as ReactComponent };